<template>
  <div ref="chart" id="chart"></div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {
      required: Array,
      default: [],
    },
  },
  mounted() {
    this.generateGraphics();
  },
  data() {
    return {
      chart: {},
    };
  },
  computed: {
    ...mapGetters([
      'am4core',
      'am4Charts',
    ]),
  },
  methods: {
    openModal(name) {
      this.$emit('show', name);
    },
    generateGraphics() {
      this.chart = this.am4core.create(this.$refs.chart, this.am4Charts.TreeMap);
      this.chart.data = this.data;
      this.chart.dataFields.value = 'quantity';
      this.chart.dataFields.name = 'letter';
      this.chart.dataFields.category = 'percentage';
      this.chart.dataFields.id = 'percentageOfGlobal';
      this.chart.layoutAlgorithm = this.chart.binaryTree;
      this.chart.zoomable = false;
      // level 0 series template
      const seriesTemplate = this.chart.seriesTemplates.create('0');
      const columnTemplate = seriesTemplate.columns.template;
      columnTemplate.events.on('hit', ({ target: { dataItem: { dataContext: { name } } } }) => {
        this.openModal(name);
      }, this);
      columnTemplate.column.cornerRadius(10, 10, 10, 10);
      columnTemplate.fillOpacity = 1;
      columnTemplate.strokeWidth = 4;
      columnTemplate.stroke = this.am4core.color('#fff');

      const bullet = seriesTemplate.bullets.push(new this.am4Charts.LabelBullet());
      bullet.locationX = 0.5;
      bullet.locationY = 0.5;
      bullet.label.hideOversized = true;
      bullet.label.truncate = true;
      bullet.label.propertyFields.html = 'label';
      bullet.label.fill = this.am4core.color('#fff');
      bullet.interactionsEnabled = false;
      this.chart.maxLevels = 5;
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.chart.data = this.data;
      },
    },
  },
};
</script>
<style scoped>
#chart {
  height: 63vh;
}
</style>




// WEBPACK FOOTER //
// src/components/reports/segmentation/distribution/DistributionGraphic.vue